import React from 'react';
import * as Ant from 'antd';
import {useOutlet} from 'reconnect.js';

const unneccessary = `
<!DOCTYPE html>
<html lang="zh-TW">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />
    <title>{subject}</title>
    <style>
      /* embed-css suggest for complex, inline-css for compatible */
      body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
        background-color: #f4f4f4;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
      }
      table {
        border-collapse: collapse;
      }
      img {
        border: 0;
        outline: none;
        text-decoration: none;
        -ms-interpolation-mode: bicubic;
      }
      a {
        text-decoration: none;
        color: #007bff;
      }
      .container {
        max-width: 800px;
        margin: 0 auto;
        background-color: #ffffff;
        border-radius: 8px;
        overflow: hidden;
      }
      .header {
        background-color: #edf8f6;
        padding: 20px 15px;
      }
      .logo {
        width: 100%;
        height: auto;
      }
      .content {
        padding: 15px 15px;
        line-height: 1.6;
        color: #333333;
      }
      .content p,.content ol, .content ul {
        margin-bottom: 5px;
      }
      .link {
        background-color: #f5f5f5;
        padding: 10px 10px;
        font-size: 12px;
        margin: 0;
      }
      .link a {
        color: #0a95d8;
      }
      .divider {
        height: 1;
        width: 100%;
        background-color: #dddddd;
        margin: 10px 0;
      }
      .footer {
        background-color: #17a98c;
        padding: 20px;
        text-align: center;
        font-size: 12px;
        color: #ffffff;
        border-top: 1px solid #eeeeee;
      }
      .footer a {
        color: #ffffff;
        text-decoration: underline;
      }
    </style>
  </head>
  <body
    style="
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      background-color: #f4f4f4;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    "
  >
  </body>
</html>
`;

const containerHtml = `<table
  width="100%"
  border="0"
  cellpadding="0"
  cellspacing="0"
  role="presentation"
  style="background-color: #f4f4f4"
>
  <tr>
    <td align="center" style="padding: 20px 0">
      <table
        class="container"
        width="100%"
        border="0"
        cellpadding="0"
        cellspacing="0"
        role="presentation"
        style="
          max-width: 800px;
          margin: 0 auto;
          background-color: #ffffff;
          border-radius: 8px;
          overflow: hidden;
        "
      >
        <tr>
          <td>
            <a href="https://www.tda.org.tw" target="_blank">
              <img
                src="https://tda.revtel2.com/images/epaper-title.png"
                alt="Logo"
                class="logo"
                style="
                  width: 100%;
                  height: auto;
                  border: 0;
                  outline: none;
                  text-decoration: none;
                  -ms-interpolation-mode: bicubic;
                "
              />
            </a>
          </td>
        </tr>

        <tr>
          <td
            class="header"
            style="background-color: #edf8f6; padding: 20px 15px"
          >
            <h3 style="margin-top: 0; margin-bottom: 5px">{subject}</h3>
            <p style="color: #777777; margin: 0; font-size: 12px">
              發刊日期：{date}
            </p>
          </td>
        </tr>

        {sections}

        <tr>
          <td
            class="footer"
            style="
              background-color: #17a98c;
              padding: 20px;
              text-align: center;
              font-size: 12px;
              color: #ffffff;
              border-top: 1px solid #eeeeee;
            "
          >
            <p style="margin: 0 0 10px 0">社團法人台北市牙醫師公會</p>
            <p style="margin: 0">
              <span>電話：02-23965392</span> |
              <span>傳真：02-23965393</span>
            </p>
            <p style="margin-top: 10px">台北市中正區忠孝東路二段120號7樓</p>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
`;

const sectionHtml = `<tr>
  <td
    class="content"
    style="padding: 15px 15px; line-height: 1.6; color: #333333"
  >
    <h4 style="margin-bottom: 10px;">{section.title}</h4>

    {section.content}

    <div style="height: 10px;"></div>

    <p
      className="link"
      style="
        background-color: #f5f5f5;
        padding: 10px 10px;
        font-size: 12px;
        margin: 0;
      "
    >
      <span>串聯網址：</span>
      <a href="{section.url}" target="_blank" style="color: #0a95d8"
        >{section.url}</a
      >
    </p>
    <p
      className="link"
      style="
        background-color: #f5f5f5;
        padding: 10px 10px;
        font-size: 12px;
        margin: 0;
      "
    >
      <span>附件檔案：</span>
      <a
        href="{section.attachment.url}"
        target="_blank"
        style="color: #0a95d8"
        >{section.attachment.name}</a
      >
    </p>

    <p
      className="divider"
      style="
        height: 1px;
        width: 100%;
        background-color: #dddddd;
        margin: 20px 0;
      "
    ></p>
  </td>
</tr>
`;

function replacer(_html, mapping, record) {
  let html = _html;
  for (let key in mapping) {
    const value = mapping[key](record);
    html = html.replaceAll(key, value);
  }
  return html;
}

function NewsletterPreview({newsletter}) {
  const sectionMapping = {
    '{section.title}': (section) => section.title,
    '{section.content}': (section) => section.content,
    '{section.url}': (section) => section.url,
    '{section.attachment.name}': (section) => section.attachment.name,
    '{section.attachment.url}': (section) => section.attachment.url,
  };

  const mapping = {
    '{subject}': (newsletter) => newsletter.subject,
    '{date}': (newsletter) => newsletter.date,
    '{sections}': (newsletter) => {
      const sections = newsletter.sections.map((section) =>
        replacer(sectionHtml, sectionMapping, section),
      );
      return sections.join('\n');
    },
  };

  const __html = React.useMemo(() => {
    return replacer(containerHtml, mapping, newsletter);
  }, [newsletter]);

  return <div dangerouslySetInnerHTML={{__html: __html}} />;
}

export default function NewsletterModal(props) {
  const [newsletter, setOpen] = useOutlet('newsletter-modal');

  return (
    <Ant.Modal
      open={!!newsletter}
      onCancel={() => setOpen(null)}
      destroyOnClose
      maskClosable
      closable
      footer={false}
      width={900}>
      {newsletter && <NewsletterPreview newsletter={newsletter} />}
    </Ant.Modal>
  );
}
